module.exports = __webpack_public_path__ + "img/jinsuolu.19c3b458.png";